module.exports = __webpack_public_path__ + "static/img/团队成员-蒋凤娓.dce2899c.jpg";